import { Component } from 'react';
import { createRemoteVideoMenuButtonEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { addIcRole, grantModerator } from '../../base/participants/actions';
import { getParticipantById } from '../../base/participants/functions';
import { IC_ROLES } from '../../base/conference/icRoles';
/**
 * Abstract dialog to confirm granting co-host to a participant.
 */
export default class AbstractGrantCoHostDialog extends Component {
    /**
     * Initializes a new {@code AbstractGrantCoHostDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    /**
     * Callback for the confirm button.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    _onSubmit() {
        const { dispatch, participantID } = this.props;
        sendAnalytics(createRemoteVideoMenuButtonEvent('grant.moderator.button', {
            'participant_id': participantID
        }));
        dispatch(grantModerator(participantID));
        dispatch(addIcRole(participantID, IC_ROLES.COHOST));
        return true;
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code AbstractGrantCoHostDialog}'s props.
 *
 * @param {IReduxState} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component.
 * @returns {IProps}
 */
export function abstractMapStateToProps(state, ownProps) {
    return {
        participantName: getParticipantById(state, ownProps.participantID)?.name
    };
}
